const swiperInfoSlide = new Swiper('.info-slider__contents', {
  loop: true,
  slidesPerView: 1.1,
  spaceBetween: 12,
  pagination: {
    el: '.info-pagination',
    clickable: true,
  },
  breakpoints: {
    580: {
      slidesPerView: 2,
    },
    980: {
      slidesPerView: 3,
    },
    1250: {
      slidesPerView: 4,
      spaceBetween: 20,
      loop: false,
    }
  }
});

document.querySelectorAll('.info-slider__item-accordion').forEach((accordion) => {
  const button = accordion.querySelector('.info-slider__acc-title');
  const content = accordion.querySelector('.info-slider__acc-content');
  const text = button.querySelector('span');

  button.addEventListener('click', () => {
    const isActive = accordion.classList.contains('active');

    if (isActive) {
      accordion.classList.remove('active');
      content.style.maxHeight = '0px';
      text.textContent = 'Tell me!';
    } else {
      accordion.classList.add('active');
      content.style.maxHeight = content.scrollHeight + 'px';
      text.textContent = 'Close';
    }
  });
});